import { Link } from '@tanstack/react-router';
import { Alert } from '../../components/ui/Alert.tsx';
import { Card, PageHeader, Spinner } from '../../components/ui/Layout.tsx';
import { MemberList } from '../members/MemberList.tsx';
import { useMembersQuery } from '../members/use-members.ts';
import { useWorkspaceQuery } from '../settings/use-workspace.ts';

/** Read-only support view of one workspace. */
export function PlatformWorkspacePage({ workspaceId }: { workspaceId: string }) {
  const workspace = useWorkspaceQuery(workspaceId);
  const members = useMembersQuery(workspaceId);
  return (
    <div className="flex flex-col gap-5">
      <Link to="/platform" className="callout font-medium text-ink-muted underline">
        ← All workspaces
      </Link>
      {workspace.isPending ? <Spinner /> : null}
      {workspace.isError ? <Alert tone="error">{workspace.error.message}</Alert> : null}
      {workspace.data ? (
        <>
          <PageHeader title={workspace.data.name} description="Read-only support view." />
          <Card title="Details">
            <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 callout">
              <dt className="text-ink-muted">Address</dt>
              <dd className="font-mono">{workspace.data.slug}</dd>
              <dt className="text-ink-muted">Plan</dt>
              <dd className="capitalize">{workspace.data.plan}</dd>
              <dt className="text-ink-muted">Time zone</dt>
              <dd>{workspace.data.timezone}</dd>
              <dt className="text-ink-muted">Status</dt>
              <dd>{workspace.data.active ? 'Active' : 'Inactive'}</dd>
            </dl>
          </Card>
        </>
      ) : null}
      <section className="flex flex-col gap-3" aria-label="Members">
        <h2 className="body font-semibold text-ink">Members</h2>
        {members.isPending ? <Spinner label="Loading members" /> : null}
        {members.isError ? <Alert tone="error">{members.error.message}</Alert> : null}
        {members.data ? <MemberList members={members.data} /> : null}
      </section>
    </div>
  );
}
